import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
  className?: string;
}

const KlubFamilyIcon: NextPage<Props> = ({
  width = "100%",
  height = "100%",
  color = "#50D77A",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7381 37.257C26.5035 37.257 30.3666 33.3939 30.3666 28.6285C30.3666 23.8631 26.5035 20 21.7381 20C16.9727 20 13.1096 23.8631 13.1096 28.6285C13.1096 33.3939 16.9727 37.257 21.7381 37.257Z"
        fill={color}
      />
      <path
        d="M71.0444 40.8676C75.8098 40.8676 79.6729 37.0045 79.6729 32.2391C79.6729 27.4737 75.8098 23.6106 71.0444 23.6106C66.279 23.6106 62.4159 27.4737 62.4159 32.2391C62.4159 37.0045 66.279 40.8676 71.0444 40.8676Z"
        fill={color}
      />
      <path
        d="M46.3629 51.4536C51.1283 51.4536 54.9914 47.5905 54.9914 42.8251C54.9914 38.0597 51.1283 34.1966 46.3629 34.1966C41.5975 34.1966 37.7344 38.0597 37.7344 42.8251C37.7344 47.5905 41.5975 51.4536 46.3629 51.4536Z"
        fill={color}
      />
      <path
        d="M32.102 64.7816C33.4833 59.3029 35.3474 55.519 35.4573 55.2866L35.461 55.2773H35.476V48.755C35.476 44.5167 32.0402 41.0803 27.8014 41.0803H15.6746C11.4361 41.0803 8 44.5167 8 48.755V74.0422H30.6934C30.866 70.6912 31.4115 67.52 32.102 64.7816Z"
        fill={color}
      />
      <path
        d="M53.9323 64.7816C55.3135 59.3029 57.1778 55.519 57.2876 55.2866L57.2914 55.2773H35.4847C35.4913 55.2913 35.533 55.3813 35.6079 55.5396C35.7536 55.8497 36.0159 56.4277 36.3454 57.2278C37.6137 60.3114 39.8539 66.7246 40.2289 74.0423H52.5236C52.6962 70.6912 53.2419 67.52 53.9323 64.7816Z"
        fill={color}
      />
      <path
        d="M84.7824 52.4574C84.7824 48.2182 81.3465 44.7827 77.1077 44.7827H64.981C60.7424 44.7827 57.3063 48.2181 57.3063 52.4574V55.2773H57.315C57.3216 55.2913 57.3632 55.3813 57.438 55.5396C57.5839 55.8497 57.8462 56.4277 58.1755 57.2278C59.444 60.3114 61.684 66.7246 62.0589 74.0423H88.0001L84.7824 52.4574Z"
        fill={color}
      />
    </svg>
  );
};

export default KlubFamilyIcon;
